import React from 'react'

import i18n from 'live/services/i18n'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { newStatetimelineReducer } from './StateTimelineReducer'
import { StateTimelineMessage, StateTimelineState } from './types'
import { withSuspenseWrapper } from '../../../components/SuspenseWrapper'

const widgetType = 'kpistatetimeline'

const WrapperStateTimelineComponent = withSuspenseWrapper(React.lazy(() => import('./component/Widget')))
const WrapperStateTimelineConfigForm = withSuspenseWrapper(React.lazy(() => import('./StateTimelineConfigForm')))

const StateTimelineWidget = reactWidgetWrapper<StateTimelineState, StateTimelineMessage, DefaultChartConfigs>(
    WrapperStateTimelineComponent,
    newStatetimelineReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        }
    }
)

const DEFAULT_CHART_CONFIG = {
    verticalEnabled: false,
    numberOfVisibleAxes: 4,
    legendEnabled: false,
    legendRight: false,
    hideTooltip: true,
    tooltipOption: 'off'
}

const policies = {
    layers: 1,
    legends: false,
    allowHideTooltip: false,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) at the end => @chain'
}

widgetService.register({
    type: widgetType,
    get name() {
        return '[KPI] State Timeline'
    },
    description: i18n('State Timeline'),
    policies,
    config: DEFAULT_CHART_CONFIG,
    ui: { configForm: WrapperStateTimelineConfigForm },
    impl: StateTimelineWidget
})
